<template>
    <div>
        <div class="page-header page-header-small">
            <div class="page-header-image splash" data-parallax="true">
            </div>
            <div class="container">
                <div class="content-center">
                    <h1 class="title">Better Plastic Solutions</h1>
                    <h2 class="subtitle">Selling New and Used<br>Plastic Molding and Auxiliary Equipment</h2>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="section-story-overview">

                <div class="row">
                    <div class="col-md-6">
                        <div class="image-container image-left">
                            <!-- First image on the left side -->
                            <p class="blockquote blockquote-primary">
                                <strong>NEW LINES or REPRESENTING</strong>
                                <ul>
                                    <li>Dri-Air Dryers</li>
                                    <li>Maguire Blenders</li>
                                    <li>Zerma Granulators/Shredders</li>
                                    <li>BOLE Injection Molding Machines</li>
                                    <li>Thermal Care Water Products</li>
                                </ul>
                                <!-- <small>-NOAA</small> -->
                            </p>
                        </div>
                        <!-- Second image on the left side of the article -->
                        <div class="image-container image-bottom"></div>
                    </div>
                    <div class="col-md-5">
                        <!-- First image on the right side, above the article -->
                        <div class="image-container image-right"></div>
                        <!-- <h3>So what does the new record for the lowest level of winter ice actually mean</h3> -->
                        <h3>Owner Ben Cleveland has been selling and servicing all forms of plastic processing equipment for 35 years. </h3>
                        <p>I stand ready to help you find a single item or help you design and lay out an entire plant.</p>
                        <p>I specialize in buying, selling new and quality used plastic processing equipment, including:</p>
                        <ul>
                            <li>Injection Molding</li>
                            <li>Blow Molding</li>
                            <li>Extrusion</li>
                            <li>Automation</li>
                            <li>Material Handling</li>
                            <li>Temperature Control</li>
                            <li>Granulation</li>
                            <li>Drying</li>
                        </ul>

                        I also maintain an inventory of used auxiliary equipment at my St. Paul warehouse. Equipment in inventory is tested to make sure it is in good operating condition whenever possible. Please contact me if you do not see the items you are looking for. Our inventory is constantly changing, and we have machinery available that's not shown here.
                    </div>
                </div>
            </div>
            <div class="separator separator-primary"></div>
            <Inventory alt></Inventory>
        </div>
        <Contact></Contact>
    </div>
</template>

<script>
import Inventory from './Inventory'
import Contact from './Contact'
export default {
    components: { Inventory, Contact },
}
</script>

<style lang="scss">
.splash {
  background-image: url("../assets/bg11.jpg");
}
.image-left {
  background-image: url("../assets/dri-air-1.png");
}
.image-right {
  background-image: url("../assets/dri-air-2.png");
}
.image-bottom {
  background-image: url("../assets/thermal-care.png");
}
.blockquote {
  width: auto !important;
}
</style>




// WEBPACK FOOTER //
// src/components/Home.vue